import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Icon } from "@sagot/ui";
import { useWorkspaceContext, useWorkspaceDetails } from "../../../../session/workspace-context";
import { NavDirection } from "../settings-direction";
import { planHasConnectors } from "./shared/states";

/** Same look as the other links of the Settings menu (`settings-page.tsx`). */
const NAV_LINK =
  "flex shrink-0 items-center gap-2.5 rounded-md px-3 py-2 text-left text-sm font-semibold text-fg-muted hover:bg-sunken hover:text-fg aria-[current=page]:bg-surface aria-[current=page]:text-fg aria-[current=page]:shadow-xs aria-[current=page]:ring-1 aria-[current=page]:ring-line";

/**
 * The "Connectors" entry of the Settings menu. The caller shows it to members with `connectors.view`; a plan without
 * Connectors keeps the entry with a lock and the page explains what the plan adds.
 */
export function ConnectorsNavLink() {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const details = useWorkspaceDetails();
  const locked = details.data !== undefined && !planHasConnectors(details.data.plan);
  return (
    <li className="shrink-0">
      <AppLink href={consoleRoutes.connectors(summary.slug)} className={NAV_LINK} data-testid="settings-nav-connectors">
        <Icon name="plug" className="size-4" />
        <span className="min-w-0">
          {t("service.connectors.title")}
          <NavDirection label={t("settings.direction.outboundCalls")} direction="outboundCalls" />
        </span>
        {locked ? (
          <>
            <Icon name="lock" className="size-3.5" aria-hidden="true" />
            <span className="sr-only">{t("service.connectors.navLocked")}</span>
          </>
        ) : null}
      </AppLink>
    </li>
  );
}
